import { Dispatch, SetStateAction } from "react";

import {
  EarlyWarningTableWidgetDataTableDaysInner,
  EarlyWarningTableWidgetDataWarningsInner,
} from "@/lib/api";

import { EarlyWarningTableToggles } from "./early-warning-table";
import EarlyWarningMapThumb from "./early-warning-map-thumb";
import Styled from "./styles";

interface EarlyWarningTableMapRowProps {
  days: EarlyWarningTableWidgetDataTableDaysInner[];
  warnings: EarlyWarningTableWidgetDataWarningsInner[];
  setToggle: Dispatch<SetStateAction<EarlyWarningTableToggles>>;
  setSelectedDay: Dispatch<SetStateAction<number>>;
}

const EarlyWarningTableMapRow = ({
  days,
  warnings,
  setToggle,
  setSelectedDay,
}: EarlyWarningTableMapRowProps) => {
  return (
    <Styled.Row>
      <td></td>
      {days.map((day, index) => (
        <td key={day.date}>
          <EarlyWarningMapThumb
            index={index}
            warnings={warnings.filter((warning) => day.warning_ids.includes(warning.id))}
            setToggle={setToggle}
            setSelectedDay={setSelectedDay}
          />
        </td>
      ))}
    </Styled.Row>
  );
};

export default EarlyWarningTableMapRow;
